module.exports = __webpack_public_path__ + "img/class1.8929ff5a.png";